export const HYPERION_API_DOMAIN = process.env.VUE_APP_HYPERION_API_DOMAIN;
export const V1_URL = process.env.VUE_APP_V1_URL;
export const AUTH0_CALLBACK = process.env.VUE_APP_AUTH0_CALLBACK;
export const AUTH0_AUDIENCE = process.env.VUE_APP_AUTH0_AUDIENCE;
export const AUTH0_DOMAIN_WHITELIST = process.env.VUE_APP_HYPERION_API_DOMAIN.split(
  ","
);
export const MAP_TILE_SERVER_STATIC =
  process.env.VUE_APP_MAP_TILE_SERVER_STATIC;
export const MAP_TILE_SERVER_DYNAMIC =
  process.env.VUE_APP_MAP_TILE_SERVER_DYNAMIC;
export const S3_CONFIG_BUCKET = process.env.VUE_APP_S3_CONFIG_BUCKET;
export const NODE_ENV = process.env.NODE_ENV;
export const DEPLOY_ENV = process.env.VUE_APP_DEPLOY_ENV;
export const X_API_KEY = process.env.VUE_APP_X_API_KEY;
export const DATADOG_APP_ID = process.env.VUE_APP_DATADOG_APP_ID;
export const DATADOG_RUM_CLIENT_TOKEN =
  process.env.VUE_APP_DATADOG_RUM_CLIENT_TOKEN;
export const POWER_OUTAGE = process.env.VUE_APP_POWER_OUTAGE;

export const PRIMARY_COLOR = "#00ae42";
export const SECONDARY_COLOR = "#a8d42e";

export const AUTH0_TENANT_CONFIGS = JSON.parse(
  process.env.VUE_APP_AUTH0_TENANTS
);
export const GRAPHQL_URL_USER_PROFILE =
  process.env.VUE_APP_GRAPHQL_URL_USER_PROFILE;
export const GRAPHQL_URL_SAVED_SEARCHES =
  process.env.VUE_APP_GRAPHQL_URL_SAVED_SEARCHES;
